import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import * as jsPDF from 'jspdf';
import * as moment from 'moment';
import { Subscription, Observable, Observer } from 'rxjs';
import { IDatosCliente } from 'src/app/shared/Entities/firmaElectronica';
import { AuthService } from 'src/app/shared/services/auth.service';
import { paths, productosPath } from '../../shared/helpers/constants';
import {
  validatePhone,
  validateEmail,
} from '../../shared/helpers/customValidators';
import { getErrorMessage } from '../../shared/helpers/validationMessages';
import { UbicationService } from '../../shared/services/ubication.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import {
  ICiudad,
  IComuna,
  IMenuItem,
  IRegion,
} from './../../shared/Entities/entities';
import { DomSanitizer } from '@angular/platform-browser';
import { downloadPdf } from '../../shared/helpers/helper';
@Component({
  selector: 'app-firma-electronica',
  templateUrl: './firma-electronica.component.html',
  styleUrls: ['./firma-electronica.component.scss'],
})
export class FirmaElectronicaComponent implements OnInit, OnDestroy {
  menuItems: IMenuItem[] = [
    {
      route: paths.firmaElectronica,
      active: true,
      children: [
        { label: 'MANDATO PRESTACIÓN DE SERVICIO A DISTANCIA', active: true },
      ],
    },
  ];
  datosContratanteVisible = false;
  firmaDigitalState: string;

  editMode = false;
  datoContratante: IDatosCliente;
  form: FormGroup;
  loading = false;
  error = false;
  regiones: IRegion[] = [];
  comunas: IComuna[] = [];
  ciudades: ICiudad[] = [];
  idPoliza: any;
  getErrorMessage = getErrorMessage;

  private subscriptions: Subscription[] = [];

  firmaVisible = false;
  srcPDF;
  dataPDF: string;
  IE = false;
  base64;

  constructor(
    private authSrv: AuthService,
    public modal: MatDialog,
    private router: Router,
    private formBuilder: FormBuilder,
    private ubicationService: UbicationService,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.idPoliza = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getBase64ImageFromURL('../../../assets/logos/logo_pdf.png').subscribe(
      base => {
        this.base64 = 'data:image/jpg;base64,' + base;
      }
    );
  }
  goDatosContratante() {
    this.datosContratanteVisible = true;
    this.loadRegion();
    this.loadData();
  }
  onEditMode() {
    this.editMode = true;
  }

  loadRegion() {
    this.ubicationService.getRegiones().subscribe(regiones => {
      this.regiones = regiones;
    });
  }

  getNombreRegionByCodigo(code: string) {
    if (!code || !this.regiones) {
      return;
    }
    const element = this.regiones.find(x => x.CodigoRegion === code);
    return element ? element.Nombre : '';
  }

  getNombreCuidadByCodigo(code: string) {
    if (!code || !this.ciudades) {
      return;
    }
    const element = this.ciudades.find(x => x.CodigoCiudad === code);
    return element ? element.Nombre : '';
  }

  getNombreComunaByCodigo(code: string) {
    if (!code || !this.comunas) {
      return '';
    }
    const element = this.comunas.find(x => x.CodigoComuna === code);
    return element ? element.Nombre : '';
  }

  loadData() {
    this.loading = true;
    this.error = false;
    const dataSubs = this.authSrv.getDatosClienteFirmaDigital().subscribe(
      data => {
        this.loading = false;
        // this.datoContratante = data;
        this.datoContratante = data;
        // this.getDatosContratante$.emit(this.datoContratante);

        this.regionOnChange({ value: this.datoContratante.COD_REGION });

        this.form = this.formBuilder.group({
          Celular: [
            this.datoContratante.CELULAR,
            { validators: [Validators.required, validatePhone] },
          ],

          Direccion: [
            this.datoContratante.DIREC,
            [Validators.required, Validators.maxLength(100)],
          ],
          Correo: [
            this.datoContratante.EMAIL,
            [Validators.required, validateEmail],
          ],
          CodigoRegion: [
            this.datoContratante.COD_REGION,
            [Validators.required],
          ],
          CodigoCiudad: [
            this.datoContratante.COD_CIUDAD,
            [Validators.required],
          ],
          CodigoComuna: [
            this.datoContratante.COD_MUNICIPIO,
            [Validators.required],
          ],
        });
        for (const i in this.form.controls) {
          if (i) {
            this.form.controls[i].markAsTouched();
          }
        }
        // this.form.markAsTouched({ onlySelf: false });
        // this.form.controls[].updateValueAndValidity();
      },
      error => {
        this.loading = false;
        this.error = true;
      }
    );

    this.subscriptions.push(dataSubs);
  }

  offEditMode() {
    this.editMode = false;
    this.loadData();
  }

  regionOnChange(event) {
    if (!event) {
      return;
    }

    this.ubicationService.getCiudades(event.value).subscribe(ciudades => {
      if (!ciudades) {
        return;
      }
      this.ciudades = ciudades.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // this.comunas = [];
      if (this.editMode) {
        this.form.patchValue(
          {
            CodigoCiudad: null,
            CodigoComuna: null,
          },
          { onlySelf: true, emitEvent: false }
        );
      } else {
        this.ciudadOnChange({ value: this.datoContratante.COD_CIUDAD });
      }
    });
  }

  ciudadOnChange(event) {
    if (!event) {
      return;
    }
    this.ubicationService.getComunas(event.value).subscribe(comunas => {
      this.comunas = comunas.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
    if (this.editMode) {
      this.form.patchValue(
        {
          CodigoComuna: null,
        },
        { onlySelf: true, emitEvent: false }
      );
    }
  }

  save() {
    if (!this.form.valid || !this.form.dirty) {
      return;
    }
    const data = {
      telefono: this.form.get('Celular').value,
      direccion: this.form.get('Direccion').value,
      correo: this.form.get('Correo').value,
      region: this.form.get('CodigoRegion').value,
      ciudad: this.form.get('CodigoCiudad').value,
      comuna: this.form.get('CodigoComuna').value,
    };

    this.authSrv.putDatosContratante(data).subscribe(res => {
      this.loadData();
      this.editMode = false;
    });
  }

  resp_generatePdf() {
    const x = 30;
    let y = 20;

    const maxX = 560;

    const doc = new jsPDF('p', 'pt', 'a4');
    const logo = new Image();
    logo.src = '../../../assets/logos/logo_pdf.jpg';
    doc.addImage(logo, 'JPEG', x, y, 180, 25);

    y += 35;
    doc.setFontSize(9);
    doc.setTextColor(35, 33, 114);
    doc.text(x, y, 'seguros vida security previsión s.a.');
    doc.setFontStyle('bold');
    doc.text(x + 440, y, 'N°	I-2500000697');

    y += 25;
    doc.setFontStyle('normal');
    doc.setFontSize(15);
    doc.text(x + 130, y, `Convenio de Prestación de Servicios a Distancia`);
    y += 15;
    doc.text(
      x + 120,
      y,
      `(Contratación electrónica y servicios de información)`
    );

    y += 10;
    doc.setDrawColor(35, 33, 114);
    doc.setLineWidth(1);
    doc.line(x, y, maxX, y);

    /* tslint:disable:max-line-length */
    const page1_p1 = `Entre Seguros Vida Security Previsión S.A., en adelante la “Compañía", por una parte y por la otra el “Cliente”, debidamente individualizado al final de este instrumento, en adelante indistintamente "el Cliente" o "el Asegurado" o "el Usuario" o "el Mandante", se celebra el siguiente Convenio de Presentación de Servicios a Distancia.`;
    const page1_p2 = `PRIMERO: El Cliente tiene actualmente contratada con la Compañía al menos una póliza de seguros de vida con o sin ahorro y/o de salud, o cualquier otro producto de la compañia, que se identifica en los sistemas de la Compañía con su número de Rut que se consigna al final del presente documento, lo que da origen a este Convenio de Prestación de Servicios a Distancia.`;
    const page1_p3 = `SEGUNDO: Por el presente instrumento las partes acuerdan que el Cliente podrá realizar, respecto de su(s) Póliza(s) actuales o futuras, las siguientes operaciones por vía electrónica:`;
    const page1_p4 = `1. Solicitar información relativa a su(s) Póliza(s), tal como beneficiarios, asegurados y fecha de vigencia.`;
    const page1_p5 = `2. Solicitar información relativa al estado de pago de las primas.`;
    const page1_p6 = `3. Solicitar información relativa a su Valor de Póliza.`;
    const page1_p7 = `4. Solicitar copia de la(s) Póliza(s).`;
    const page1_p8 = `5. Solicitar  cotizaciones  relativas  a  las  modificaciones  de  la(s)  Póliza(s)  actualmente  vigentes,  ya  sea,  por modificación del número de personas aseguradas o de las contingencias cubiertas.`;
    const page1_p9 = `6. Solicitar modificaciones de la(s) Póliza(s) vigentes o su renovación.`;
    const page1_p10 = `7. Efectuar cambio de domicilio.`;
    const page1_p11 = `8. Realizar transferencias entre fondos de inversión o entre alternativas de inversión, donde se encuentren invertidas las primas pagadas, si se trata de un seguro de vida individual con rentabilidad variable.`;
    const page1_p12 = `9. Revisar directamente su cartola de saldo y movimiento y/o solicitar su envío.`;
    const page1_p13 = `10. Revisar gráfica de los valores cuota de los fondos mutuos, relacionados al seguro de vida con rentabilidad variable.`;
    const page1_p14 = `11. Cualquier otra operación que en el futuro implemente la Compañía. La sola ejecución por el Cliente de cualquier nueva operación que ponga en servicio la Compañía, aún por una sola ocasión, importará aceptación del primero de su incorporación al presente contrato, al cual quedará sometido y se regirá por sus estipulaciones.`;
    const page1_p15 = `TERCERO: El Cliente podrá efectuar las operaciones antes indicadas, en la medida que la Compañía las tenga implementadas, mediante el uso de alguno de los siguientes medios de comunicación:`;
    const page1_p16 = `a. Vía telefónica o mail a través del servicio Contact Center de la Compañía.`;
    const page1_p17 = `b. A través del sitio web de la compañia, www.vidasecurity.cl o el que le reemplace.`;
    const page1_p18 = `c. Mediante otros medios de comunicación que en el futuro implemente la Compañía. En todo caso, el sólo uso por el Cliente de estos medios, que ponga en funcionamiento la Compañía, aún por una sola ocasión, importará aceptación de su incorporación al presente contrato, al cual quedará sometido y se regirá por sus estipulaciones.`;
    const page1_p19 = `CUARTO: La realización de las operaciones que efectúe el Cliente por los medios de comunicación antes señalados, se ajustarán a las siguientes condiciones:`;
    const page1_p20 = `1. Las operaciones las efectuará el Cliente, proporcionando su número de Rut, seguido del número secreto personal registrado en los sistemas computacionales de la Compañía.`;
    const page1_p21 = `2. El Cliente, en pleno conocimiento de la normativa vigente sobre seguros y de las responsabilidades civiles y penales que pueden derivarse de ella, instruye a la Compañía para que acepte y entienda que todo llamado telefónico o conexión computacional que efectúe alguna persona dando el número secreto además de su número de Rut, se tendrá como hecho por el propio cliente. En tal caso, y cumplidos dichos requisitos, la Compañía podrá considerar que tal instrucción ha emanado válida, legítima y auténticamente del Cliente, sin necesidad de efectuar, realizar, o tomar ningún otro resguardo, de ninguna índole, aceptando el Cliente que no deberá acreditarse a la Compañía ni a terceros el hecho de la consulta, o el haber dado efectivamente la instrucción. Del mismo modo, el Cliente renuncia por el presente acto a objetar o negar a la Compañía o a terceros el hecho de haberse dado la instrucción telefónica o computacional respectiva, para todos los servicios a que se refiere este convenio. Reconoce el Cliente que las declaraciones formuladas en este numeral son para la Compañía esenciales y han sido condición determinante para que éste celebre el presente convenio.`;
    const page1_p22 = `3. Las modalidades utilizadas por la Compañía, para efectos de la presentación de servicios a que se refiere el presente convenio, podrán efectuarse mediante un sistema automático o vía operadora, según lo disponga la Compañía.`;
    const page1_p23 = `4. La información proporcionada por la Compañía bajo las señaladas condiciones tendrá carácter de esencialmente provisoria y estará sujeta a confirmación en las oficinas de la Compañía.`;
    const page1_p24 = `5. La Compañía podrá cobrar comisiones por el servicio de envío de copia de póliza a domicilio o por mail, por la mantención y/o uso del servicio Call Center o por servicios que en el futuro ponga en funcionamiento, así como también modificar dichas comisiones, ambas cosas previo aviso escrito al Cliente entendiéndose facultada expresamente la Compañía para efectuar los correspondientes cargos.`;
    const page1_p25 = `6. Los servicios que implemente la Compañía, se prestarán en la forma, horarios y lugares que determine libremente la misma Compañía, no siéndole obligatoria la prestación de ellos.`;

    let splitText = doc.splitTextToSize(page1_p1, maxX - x - 30);

    y += 10;
    doc.setFontSize(10);
    doc.text(splitText, x, y, { maxWidth: maxX - 28, align: 'justify' });
    y += 45;
    doc.text(page1_p2, x, y, { maxWidth: maxX - 35, align: 'justify' });
    y += 55;
    doc.text(page1_p3, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p4, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p5, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p6, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p7, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p8, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p9, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p10, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p11, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p12, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p13, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p14, x, y, { maxWidth: maxX, align: 'justify' });
    y += 45;
    doc.text(page1_p15, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p16, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p17, x, y, { maxWidth: maxX, align: 'justify' });
    y += 15;
    doc.text(page1_p18, x, y, { maxWidth: maxX, align: 'justify' });
    y += 45;
    doc.text(page1_p19, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p20, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p21, x, y, { maxWidth: maxX, align: 'justify' });
    y += 115;
    doc.text(page1_p22, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p23, x, y, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(page1_p24, x, y, { maxWidth: maxX, align: 'justify' });
    y += 45;
    doc.text(page1_p25, x, y, { maxWidth: maxX, align: 'justify' });

    const page2_p1 = `7. La Compañía queda absolutamente liberada de toda responsabilidad por perjuicios que puedan ocasionarse al cliente o a terceros en caso de suspensión de los sistemas establecidos en el presente contrato, por cualquier causa que ello ocurriere.`;
    const page2_p2 = `8. El Cliente acepta que las órdenes dadas en horarios no hábiles puedan ser ejecutadas dentro del horario hábil siguiente, por lo que, dichas órdenes no son instantáneas.`;

    const page2_p3 = `QUINTO: El Cliente acepta que la Compañía le informe que cualquier comunicación, declaración o notificación que haya de hacerse entre la Compañía, el Cliente o Contratante, el Asegurado o sus Beneficiarios con motivo de esta(s) Póliza(s), deberá realizarse por correo electrónico, registrado para estos efectos en las condiciones particulares o certificados correspondientes, según sea el caso, la cual se entenderá como recibida al día hábil siguiente de haberse enviado éstas, independientemente de la fecha en que el Contratante, Asegurado o Beneficiario haya dado lectura al mismo. Asimismo, el Contratante, Asegurado y Beneficiario serán responsables por la privacidad de este medio de comunicación, siendo de su exclusiva responsabilidad, la revisión, lectura y administración de los documentos enviados o su posible delegación a un tercero. Para estos efectos el Cliente declara el siguiente correo electrónico:`;

    const page2_p4 = `Ingrese su correo electrónico con letra imprenta (dos veces como verificación):`;

    doc.addPage();
    splitText = doc.splitTextToSize(page2_p1, maxX);
    y = 10;
    doc.text(x, y, splitText, { maxWidth: maxX, align: 'justify' });
    y += 25;
    doc.text(x, y, page2_p2, { maxWidth: maxX, align: 'justify' });
    y += 35;
    doc.text(x, y, page2_p3, { maxWidth: maxX, align: 'justify' });
    y += 115;
    doc.text(x, y, page2_p4, { maxWidth: maxX, align: 'justify' });

    /* const mailTable = document.getElementById('mailTable');
    doc.table(x, y, [{ mail: 'mail' }], [], {}); */

    y += 25;
    doc.setLineWidth(0.5);
    doc.line(x, y, maxX, y);
    y += 10;
    doc.text(
      x,
      y,
      this.datoContratante.EMAIL ? this.datoContratante.EMAIL : ''
    );
    y += 5;
    doc.line(x, y, maxX, y);
    y += 10;
    doc.text(
      x,
      y,
      this.datoContratante.EMAIL ? this.datoContratante.EMAIL : ''
    );
    y += 5;
    doc.line(x, y, maxX, y);

    const page2_p5 = `Sin perjuicio de lo anterior, respecto de la comunicación, declaración o notificación, la Compañía podrá efectuarla por escrito, mediante carta certificada u otro medio fehaciente que demuestre la recepción del comunicado, dirigida al último domicilio del Contratante, registrado en las condiciones particulares de la Póliza. Las notificaciones hechas por carta certificada, se entenderán realizadas al tercer día hábil siguiente al ingreso a correos de la carta, según timbre que conste en el sobre respectivo.`;

    const page2_p6 = `SEXTO: El Cliente autoriza expresamente a Vida Security S.A. para comunicar, compartir, transmitir y proporcionar en forma exclusiva a las empresas relacionadas, según se define en el Artículo 100 de la Ley N° 18.045 y, en general, hacer tratamiento de sus datos de carácter personal de naturaleza no sensible, en los términos y condiciones establecidos en la Ley N° 19.628 sobre protección de datos privados y sus modificaciones, cuando ello fuere necesario o conveniente para la materialización o implementación de promociones, así como también para agilizar las respuestas o evaluaciones comerciales o la implementación de nuevos desarrollos tecnológicos que permitan al Cliente operar de manera integrada y eficiente en las diversas plataformas tecnológicas y sus empresas relacionadas.
Asimismo, en este acto y por el presente instrumento, Vida Security S.A. cumple con su obligación legal e informa al Cliente de modo expreso, preciso, claro e inequívoco, acerca de la existencia de un registro de datos personales en el cual se consignará la información proporcionada, siendo Vida Security S.A. el responsable del registro.

Esta autorización es válida y se hace extensiva también a todas las demás empresas relacionadas, las cuales podrán a su vez comunicar, compartir, transmitir y proporcionar a Vida Security, y en general, a todas las empresas relacionadas, la información antes señalada.`;

    const page2_p7 = `SÉPTIMO: Conforme a la Circular 2.122 de la Superintendencia de Valores y Seguros de fecha 22 de octubre de 2013, el Cliente acepta que la información cuatrimestral de saldos, cargos, abonos y rentabilidad de Pólizas de APV le sea puesta a su disposición, a través, del sitio web de la Compañía sin necesidad que ésta sea despachada a su domicilio.`;

    const page2_p8 = `OCTAVO: Será de cargo del Cliente los impuestos que correspondan a cada operación ejecutada, si la misma estuviese gravada.`;

    const page2_p9 = `NOVENO: El presente contrato tendrá vigencia indefinida, no obstante, de procederse a la cancelación de la Póliza por no pago de prima, el presente contrato terminará anticipadamente al momento de dicha cancelación.`;

    const page2_p10 = `DÉCIMO: Para todos los efectos legales, las partes fijan domicilio en las condiciones particulares de la(s) Póliza(s) y ante cualquier controversia judicial o extrajudicial se someten al método de resolución de conflictos establecido en la(s) Pólizas.
`;

    splitText = doc.splitTextToSize(page2_p5, maxX - 100);
    y += 20;
    doc.text(x, y, splitText, { maxWidth: maxX, align: 'justify' });
    y += 65;
    doc.text(x, y, page2_p6, { maxWidth: maxX, align: 'justify' });
    y += 160;
    doc.text(x, y, page2_p7, { maxWidth: maxX, align: 'justify' });
    y += 45;
    doc.text(x, y, page2_p8, { maxWidth: maxX, align: 'justify' });
    y += 35;
    doc.text(x, y, page2_p9, { maxWidth: maxX, align: 'justify' });
    y += 35;
    doc.text(x, y, page2_p10, { maxWidth: maxX, align: 'justify' });

    y += 80;
    doc.cellInitialize();
    const cellH = 20;
    let cellX = x;
    let cellW = 135;

    // const nombreSplit = this.datoContratante.Nombre.split(' ');

    doc.cell(cellX, y, cellW - 20, cellH, 'Rut Contratante', 1, 'left');
    doc.cell(cellX, y, cellW + 2.5, cellH, 'Apellido Paterno', 1, 'left');
    doc.cell(cellX, y, cellW, cellH, 'Apellido Materno', 1, 'left');
    doc.cell(cellX, y, cellW + 2.5, cellH, 'Nombres', 1, 'left');
    doc.cell(cellX, y, cellW - 20, cellH, this.datoContratante.RUT, 2, 'left');
    doc.cell(
      cellX,
      y,
      cellW + 2.5,
      cellH,
      this.datoContratante.APEPATER,
      2,
      'left'
    );
    doc.cell(cellX, y, cellW, cellH, this.datoContratante.APEMATER, 2, 'left');
    doc.cell(
      cellX,
      y,
      cellW + 2.5,
      cellH,
      this.datoContratante.NOMTER,
      2,
      'left'
    );

    doc.cellInitialize();
    y += 50;
    cellX = x;
    cellW = 250;
    doc.cell(
      cellX,
      y,
      cellW,
      cellH,
      'Dirección particular (calle, número, depto.)',
      1,
      'left'
    );
    cellW = 250;
    doc.cell(cellX, y, cellW, cellH, this.datoContratante.DIREC, 2, 'left');

    cellX = x;
    cellW = 125;
    doc.cell(cellX, y, cellW, cellH, 'Comuna', 3, 'left');
    doc.cell(cellX, y, cellW, cellH, 'Ciudad', 3, 'left');
    doc.cellInitialize();
    y += cellH * 3;
    doc.cell(
      cellX,
      y,
      cellW,
      cellH,
      this.getNombreComunaByCodigo(this.datoContratante.COD_MUNICIPIO),
      1,
      'left'
    );
    doc.cell(
      cellX,
      y,
      cellW,
      cellH,
      this.getNombreCuidadByCodigo(this.datoContratante.COD_CIUDAD),
      1,
      'left'
    );

    y -= cellH * 3;
    doc.cellInitialize();
    cellX = x + 255;
    cellW = 100;
    doc.cell(cellX, y, cellW, cellH, 'En (ciudad de firma)', 1, 'left');
    doc.cell(cellX, y, cellW, cellH, 'INTERNET', 2, 'left');
    doc.cell(cellX, y, cellW, cellH, 'Fecha', 3, 'left');
    doc.cellInitialize();
    y += cellH * 3;
    doc.cell(cellX, y, cellW, cellH, moment().format('DD-MM-YYYY'), 1, 'left');

    doc.cellInitialize();
    y -= cellH * 3;
    cellX += cellW;
    cellW = 170;

    doc.cell(
      cellX,
      y,
      cellW,
      cellH * 4,
      '                Firma Cliente',
      1,
      ''
    );

    this.srcPDF = doc.output('datauristring');

    // doc.output('dataurlnewwindow');

    /* const fileName = 'example.pdf';
    doc.save(fileName); */
  }

  getBase64ImageFromURL(url: string) {
    return Observable.create((observer: Observer<string>) => {
      // create an image object
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        // This will call another method that will create image from url
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = err => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    // We create a HTML canvas object that will create a 2d image
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d'); // This will draw image
    ctx.drawImage(img, 0, 0);
    // Convert the drawn image to Data URL
    const dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }

  generatePdf() {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const dd = {
      pageSize: 'LETTER',
      pageMargins: [40, 60],
      content: [
        { image: this.base64, width: 180, height: 25 },
        {
          text: 'seguros vida security previsión s.a.',
          style: ['head1', 'marginBottom'],
        },
        { text: 'N°	I-2500000697', style: ['head2', 'marginBottom'] },
        {
          text: 'Convenio de Prestación de Servicios a Distancia',
          style: 'header',
        },
        {
          text: '(Contratación electrónica y servicios de información)',
          style: 'header',
        },
        {
          text:
            '__________________________________________________________________________________________________',
          style: ['margin_line', 'defaultStyle'],
        },
        {
          text:
            'Entre Seguros Vida Security Previsión S.A., en adelante la “Compañía", por una parte y por la otra el “Cliente”, debidamente individualizado al final de este instrumento, en adelante indistintamente "el Cliente" o "el Asegurado" o "el Usuario" o "el Mandante", se celebra el siguiente Convenio de Presentación de Servicios a Distancia.',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'PRIMERO: El Cliente tiene actualmente contratada con la Compañía al menos una póliza de seguros de vida con o sin ahorro y/o de salud, o cualquier otro producto de la compañia, que se identifica en los sistemas de la Compañía con su número de Rut que se consigna al final del presente documento, lo que da origen a este Convenio de Prestación de Servicios a Distancia.',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'SEGUNDO: Por el presente instrumento las partes acuerdan que el Cliente podrá realizar, respecto de su(s) Póliza(s) actuales o futuras, las siguientes operaciones por vía electrónica:',
          style: 'paragraph',
        },
        {
          ol: [
            {
              text:
                'Solicitar información relativa a su(s) Póliza(s), tal como beneficiarios, asegurados y fecha de vigencia.',
              style: 'paragraph',
            },
            {
              text:
                'Solicitar información relativa al estado de pago de las primas.',
              style: 'paragraph',
            },
            {
              text: 'Solicitar información relativa a su Valor de Póliza.',
              style: 'paragraph',
            },
            { text: 'Solicitar copia de la(s) Póliza(s).', style: 'paragraph' },
            {
              text:
                'Solicitar  cotizaciones  relativas  a las modificaciones de la(s) Póliza(s) actualmente vigentes, ya sea, por modificación del número de personas aseguradas o de las contingencias cubiertas.',
              style: 'paragraph',
            },
            {
              text:
                'Solicitar modificaciones de la(s) Póliza(s) vigentes o su renovación.',
              style: 'paragraph',
            },
            { text: 'Efectuar cambio de domicilio.', style: 'paragraph' },
            {
              text:
                'Realizar transferencias entre fondos de inversión o entre alternativas de inversión, donde se encuentren invertidas las primas pagadas, si se trata de un seguro de vida individual con rentabilidad variable.',
              style: 'paragraph',
            },
            {
              text:
                'Revisar directamente su cartola de saldo y movimiento y/o solicitar su envío.',
              style: 'paragraph',
            },
            {
              text:
                'Revisar gráfica de los valores cuota de los fondos mutuos, relacionados al seguro de vida con rentabilidad variable.',
              style: 'paragraph',
            },
            {
              text:
                'Cualquier otra operación que en el futuro implemente la Compañía. La sola ejecución por el Cliente de cualquier nueva operación que ponga en servicio la Compañía, aún por una sola ocasión, importará aceptación del primero de su incorporación al presente contrato, al cual quedará sometido y se regirá por sus estipulaciones.',
              style: ['paragraph', 'marginBottom'],
            },
          ],
          style: 'paragraph',
        },
        {
          text:
            'TERCERO: El Cliente podrá efectuar las operaciones antes indicadas, en la medida que la Compañía las tenga implementadas, mediante el uso de alguno de los siguientes medios de comunicación:',
          style: 'paragraph',
        },
        {
          type: 'lower-alpha',
          ol: [
            {
              text:
                'Vía telefónica o mail a través del servicio Contact Center de la Compañía.',
              style: 'paragraph',
            },
            {
              text:
                'A través del sitio web de la compañia, www.vidasecurity.cl o el que le reemplace.',
              style: 'paragraph',
            },
            {
              text:
                'Mediante otros medios de comunicación que en el futuro implemente la Compañía. En todo caso, el sólo uso por el Cliente de estos medios, que ponga en funcionamiento la Compañía, aún por una sola ocasión, importará aceptación de su incorporación al presente contrato, al cual quedará sometido y se regirá por sus estipulaciones.',
              style: ['paragraph', 'marginBottom'],
            },
          ],
          style: 'paragraph',
        },
        {
          text:
            'CUARTO: La realización de las operaciones que efectúe el Cliente por los medios de comunicación antes señalados, se ajustarán a las siguientes condiciones:',
          style: 'paragraph',
        },
        {
          ol: [
            {
              text:
                'Las operaciones las efectuará el Cliente, proporcionando su número de Rut, seguido del número secreto personal registrado en los sistemas computacionales de la Compañía.',
              style: 'paragraph',
            },
            {
              text:
                'El Cliente, en pleno conocimiento de la normativa vigente sobre seguros y de las responsabilidades civiles y penales que pueden derivarse de ella, instruye a la Compañía para que acepte y entienda que todo llamado telefónico o conexión computacional que efectúe alguna persona dando el número secreto además de su número de Rut, se tendrá como hecho por el propio cliente. En tal caso, y cumplidos dichos requisitos, la Compañía podrá considerar que tal instrucción ha emanado válida, legítima y auténticamente del Cliente, sin necesidad de efectuar, realizar, o tomar ningún otro resguardo, de ninguna índole, aceptando el Cliente que no deberá acreditarse a la Compañía ni a terceros el hecho de la consulta, o el haber dado efectivamente la instrucción. Del mismo modo, el Cliente renuncia por el presente acto a objetar o negar a la Compañía o a terceros el hecho de haberse dado la instrucción telefónica o computacional respectiva, para todos los servicios a que se refiere este convenio. Reconoce el Cliente que las declaraciones formuladas en este numeral son para la Compañía esenciales y han sido condición determinante para que éste celebre el presente convenio.',
              style: 'paragraph',
            },
            {
              text:
                'Las modalidades utilizadas por la Compañía, para efectos de la presentación de servicios a que se refiere el presente convenio, podrán efectuarse mediante un sistema automático o vía operadora, según lo disponga la Compañía.',
              style: 'paragraph',
            },
            {
              text:
                'La información proporcionada por la Compañía bajo las señaladas condiciones tendrá carácter de esencialmente provisoria y estará sujeta a confirmación en las oficinas de la Compañía.',
              style: 'paragraph',
            },
            {
              text:
                'La Compañía podrá cobrar comisiones por el servicio de envío de copia de póliza a domicilio o por mail, por la mantención y/o uso del servicio Call Center o por servicios que en el futuro ponga en funcionamiento, así como también modificar dichas comisiones, ambas cosas previo aviso escrito al Cliente entendiéndose facultada expresamente la Compañía para efectuar los correspondientes cargos.',
              style: 'paragraph',
            },
            {
              text:
                'Los servicios que implemente la Compañía, se prestarán en la forma, horarios y lugares que determine libremente la misma Compañía, no siéndole obligatoria la prestación de ellos.',
              style: 'paragraph',
            },
            {
              text:
                'La Compañía queda absolutamente liberada de toda responsabilidad por perjuicios que puedan ocasionarse al cliente o a terceros en caso de suspensión de los sistemas establecidos en el presente contrato, por cualquier causa que ello ocurriere.',
              style: 'paragraph',
            },
            {
              text:
                'El Cliente acepta que las órdenes dadas en horarios no hábiles puedan ser ejecutadas dentro del horario hábil siguiente, por lo que, dichas órdenes no son instantáneas.',
              style: ['paragraph', 'marginBottom'],
            },
          ],
          style: 'paragraph',
        },
        {
          text:
            'QUINTO: El Cliente acepta que la Compañía le informe que cualquier comunicación, declaración o notificación que haya de hacerse entre la Compañía, el Cliente o Contratante, el Asegurado o sus Beneficiarios con motivo de esta(s) Póliza(s), deberá realizarse por correo electrónico, registrado para estos efectos en las condiciones particulares o certificados correspondientes, según sea el caso, la cual se entenderá como recibida al día hábil siguiente de haberse enviado éstas, independientemente de la fecha en que el Contratante, Asegurado o Beneficiario haya dado lectura al mismo. Asimismo, el Contratante, Asegurado y Beneficiario serán responsables por la privacidad de este medio de comunicación, siendo de su exclusiva responsabilidad, la revisión, lectura y administración de los documentos enviados o su posible delegación a un tercero. Para estos efectos el Cliente declara el siguiente correo electrónico:',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'Ingrese su correo electrónico con letra imprenta (dos veces como verificación):',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            '__________________________________________________________________________________________________',
          style: 'defaultStyle',
        },
        {
          text: this.datoContratante.EMAIL ? this.datoContratante.EMAIL : '',
          style: 'paragraph',
        },
        {
          text:
            '__________________________________________________________________________________________________',
          style: ['margin_line', 'defaultStyle'],
        },
        {
          text: this.datoContratante.EMAIL ? this.datoContratante.EMAIL : '',
          style: 'paragraph',
        },
        {
          text:
            '__________________________________________________________________________________________________',
          style: 'marginLastLineEmail',
        },
        {
          text:
            'Sin perjuicio de lo anterior, respecto de la comunicación, declaración o notificación, la Compañía podrá efectuarla por escrito, mediante carta certificada u otro medio fehaciente que demuestre la recepción del comunicado, dirigida al último domicilio del Contratante, registrado en las condiciones particulares de la Póliza. Las notificaciones hechas por carta certificada, se entenderán realizadas al tercer día hábil siguiente al ingreso a correos de la carta, según timbre que conste en el sobre respectivo.',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'SEXTO: El Cliente autoriza expresamente a Vida Security S.A. para comunicar, compartir, transmitir y proporcionar en forma exclusiva a las empresas relacionadas, según se define en el Artículo 100 de la Ley N° 18.045 y, en general, hacer tratamiento de sus datos de carácter personal de naturaleza no sensible, en los términos y condiciones establecidos en la Ley N° 19.628 sobre protección de datos privados y sus modificaciones, cuando ello fuere necesario o conveniente para la materialización o implementación de promociones, así como también para agilizar las respuestas o evaluaciones comerciales o la implementación de nuevos desarrollos tecnológicos que permitan al Cliente operar de manera integrada y eficiente en las diversas plataformas tecnológicas y sus empresas relacionadas. Asimismo, en este acto y por el presente instrumento, Vida Security S.A. cumple con su obligación legal e informa al Cliente de modo expreso, preciso, claro e inequívoco, acerca de la existencia de un registro de datos personales en el cual se consignará la información proporcionada, siendo Vida Security S.A. el responsable del registro. Esta autorización es válida y se hace extensiva también a todas las demás empresas relacionadas, las cuales podrán a su vez comunicar, compartir, transmitir y proporcionar a Vida Security, y en general, a todas las empresas relacionadas, la información antes señalada.',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'SÉPTIMO: Conforme a la Circular 2.122 de la Superintendencia de Valores y Seguros de fecha 22 de octubre de 2013, el Cliente acepta que la información cuatrimestral de saldos, cargos, abonos y rentabilidad de Pólizas de APV le sea puesta a su disposición, a través, del sitio web de la Compañía sin necesidad que ésta sea despachada a su domicilio.',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'OCTAVO: Será de cargo del Cliente los impuestos que correspondan a cada operación ejecutada, si la misma estuviese gravada.',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'NOVENO: El presente contrato tendrá vigencia indefinida, no obstante, de procederse a la cancelación de la Póliza por no pago de prima, el presente contrato terminará anticipadamente al momento de dicha cancelación.',
          style: ['paragraph', 'marginBottom'],
        },
        {
          text:
            'DÉCIMO: Para todos los efectos legales, las partes fijan domicilio en las condiciones particulares de la(s) Póliza(s) y ante cualquier controversia judicial o extrajudicial se someten al método de resolución de conflictos establecido en la(s) Pólizas.',
          style: ['paragraph', 'marginBottom'],
        },

        {
          style: ['tableExample', 'marginBottom'],
          color: '#232172',
          table: {
            widths: [122, 123, 124, 125],
            body: [
              [
                {
                  text: 'Rut Contratante',
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
                {
                  text: 'Apellido Paterno',
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
                {
                  text: 'Apellido Materno',
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
                {
                  text: 'Nombres',
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
              ],
              [
                {
                  text: this.datoContratante.RUT,
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
                {
                  text: this.datoContratante.APEPATER,
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
                {
                  text: this.datoContratante.APEMATER,
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
                {
                  text: this.datoContratante.NOMTER,
                  borderColor: ['#232172', '#232172', '#232172', '#232172'],
                },
              ],
            ],
          },
        },
        {
          columns: [
            {
              style: 'tableExample',
              table: {
                widths: [122, 122],
                body: [
                  [
                    {
                      text: 'Dirección particular (calle, número, depto.)',
                      colSpan: 2,
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    {},
                  ],
                  [
                    {
                      text: this.datoContratante.DIREC,
                      colSpan: 2,
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    {},
                  ],
                  [
                    {
                      text: 'Comuna',
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    {
                      text: 'Ciudad',
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                  ],
                  [
                    {
                      text: this.getNombreComunaByCodigo(
                        this.datoContratante.COD_MUNICIPIO
                      ),
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    {
                      text: this.getNombreCuidadByCodigo(
                        this.datoContratante.COD_CIUDAD
                      ),
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                  ],
                ],
              },
            },
            {
              style: 'tableExample',
              table: {
                widths: [105, 142],
                body: [
                  [
                    {
                      text: 'En (ciudad de firma)',
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    {
                      rowSpan: 4,
                      text: 'Firma Cliente',
                      alignment: 'center',
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                  ],
                  [
                    {
                      text: 'INTERNET',
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    '',
                  ],
                  [
                    {
                      text: 'Fecha',
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    '',
                  ],
                  [
                    {
                      text: moment().format('DD-MM-YYYY'),
                      borderColor: ['#232172', '#232172', '#232172', '#232172'],
                    },
                    '',
                  ],
                ],
              },
            },
          ],
        },
      ],
      styles: {
        logo: {
          alignment: 'left',
        },
        head1: {
          alignment: 'left',
          fontSize: 9,
          font: 'Roboto',
          color: '#232172',
        },
        head2: {
          alignment: 'right',
          bold: true,
          fontSize: 9,
          font: 'Roboto',
          color: '#232172',
        },
        header: {
          alignment: 'center',
          bold: true,
          fontSize: 15,
          font: 'Roboto',
          color: '#232172',
        },
        margin_line: {
          margin: [0, -10, 0, 0],
        },
        anotherStyle: {
          italics: true,
          alignment: 'right',
        },
        paragraph: {
          alignment: 'justify',
          fontSize: 10,
          font: 'Roboto',
          color: '#232172',
        },
        tableExample: {
          fontSize: 10,
          font: 'Roboto',
          color: '#232172',
        },
        marginBottom: {
          margin: [0, 0, 0, 10],
        },
        marginLastLineEmail: {
          margin: [0, -10, 0, 25],
          font: 'Roboto',
          color: '#232172',
        },
        defaultStyle: {
          font: 'Roboto',
          color: '#232172',
        },
      },
    };

    const tempPdf = pdfMake.createPdf(dd);
    tempPdf.getBlob(blob => {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        this.IE = true;
        this.srcPDF = window.navigator.msSaveOrOpenBlob(blob, 'pdf_firma.pdf');
      } else {
        const url = URL.createObjectURL(blob);
        this.srcPDF = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      }
    });
    tempPdf.getBase64(base => {
      this.dataPDF = base;
    });
  }

  downloadPdfFirma() {
    downloadPdf(this.dataPDF, 'pdf_firma.pdf');
  }

  goToFirmar() {
    this.datosContratanteVisible = false;
    this.firmaVisible = true;

    // this.srcPDF = '../../../assets/convenioPrestacionServicioDistancia.pdf';

    this.generatePdf();
  }

  clearAccents(str: string): string {
    if (!str) {
      return '';
    }
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  firmar() {
    const data = {
      IdConvenio: `${this.idPoliza}`,
      rut: this.datoContratante.RUT,
      nombre: this.clearAccents(this.datoContratante.NOMTER),
      apellido: this.clearAccents(this.datoContratante.APEPATER),
      email: this.datoContratante.EMAIL,
      tipoFirma: 1,
      extensionArchivo: 'application/pdf',
      archivador: 'Seguros Individuales',
      Index: [
        {
          Label: 'EMPRESA',
          Value: 'VIDA SECURITY',
        },
        {
          Label: 'POLIZA',
          Value: this.idPoliza,
        },
        {
          Label: 'RUTASEGURADO',
          Value: this.datoContratante.RUT,
        },
        {
          Label: 'NOMBRECONTRATANTE',
          Value: this.clearAccents(this.datoContratante.NOMTER),
        },
      ],
      usuario: this.clearAccents(this.datoContratante.NOMTER),
      archivo: this.dataPDF,
    };

    const firmarSubs = this.authSrv.postMandatoFirma(data).subscribe(
      res => {
        this.firmaVisible = false;
        this.firmaDigitalState = 'valid';
        localStorage.setItem('validFirmaDigital', '1');
      },
      err => {
        this.firmaDigitalState = 'invalid';
        localStorage.setItem('validFirmaDigital', '0');
        this.firmaVisible = false;
      }
    );
    this.subscriptions.push(firmarSubs);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  goToTraslado() {
    this.router.navigate(
      [
        productosPath.children.individual.rootPath +
          '/' +
          productosPath.children.individual.path +
          '/' +
          productosPath.children.individual.children.detalle.path.split('/')[0],
        this.idPoliza,
      ],
      {
        queryParams: {
          tab: 'traslados',
        },
      }
    );
  }
}
